import { Injector } from "@angular/core";

export const AppConstants = {
  urls: {
    app: {
      login: "login",
      apptype: {
        Report: 25,
      },
    },
    api: {
       base: "https://utp.edu-man.com/ut/api/",
      // base: "http://95.216.234.30:1007/utuat/api/", // Live UT
      //base: "http://192.168.1.177:4321/ut/api/",

      application: "",
      //reportNGUrl: "http://localhost:4200/#/",
      //reportNGUrl: "http://uatreports.edu-man.com/#/",
       reportNGUrl: "https://reportsp.edu-man.com/#/",
      reportUrl: "https://portalp.edu-man.com/WebForms/DevExReportViewer.aspx",
      // reportUrl: "http://portal.skobus.com/WebForms/DevExReportViewer.aspx"
      //reportUrl: "http://95.216.234.30:6009/WebForms/DevExReportViewer.aspx"
      //reportUrl: "http://localhost:6005/WebForms/DevExReportViewer.aspx",
    },
  },
  settings: {
    appName: "EDU-MAN",
    appCode: "SB",
    instanceid: 23,
    instancecode: "SM022",
    dateFormat: "dd-MMM-yyyy",
    timeFormat: "HH:mm:ss",
    dateFormatforString: "DD-MMM-YYYY",
    timeFormatforString: "hh:mm:ss A",
    timeFormatTile: "hh:mm A",
    dateAndTime: "YYYY-MM-DDTHH:mm",
  },
  policy: {
    dateFormat: "",
    timeFormat: "",
    gridpagging: false,
    defaultcityid: 0,
    defaultctryid: 0,
  },
  injector: <Injector>{},
};
